<template>
    <form-switch
        v-model="value"
        @change="onChange"
        :font-size="13"
        :width="89"
        :height="25"
        :labels="{ checked: 'Enabled', unchecked: 'Disabled' }"
    />
</template>

<script>
import FormSwitch from '../../../generic/form-switch/form-switch.vue';

export default {
    components: { FormSwitch },
    data() {
        return { value: false };
    },
    created() {
        this.value = this.params.value;
    },
    methods: {
        setNewValue(newValue) {
            if (typeof this.params.onChange === 'function') {
                this.value = newValue;
                if (this.params.onChange) {
                    this.params.onChange(this.params, newValue);
                }
            }
        },
        onChange({ value }) {
            var newValue = value;
            this.value = !value;
            this.setNewValue(newValue);
        },
    },
};
</script>
